module.exports = __webpack_public_path__ + "img/6.ab8a0985.png";